export default {
  title: 'Country/Region Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Country name, code',
    continent: 'Continent',
    continentPlaceholder: 'Select continent',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addCountryRegion: 'Add Country/Region',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enableItem: 'Enable',
    disableItem: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    nameEn: 'English Name',
    nameCn: 'Chinese Name',
    code: 'Code',
    continent: 'Continent',
    areaCode: 'Area Code',
    status: 'Status',
    operation: 'Operation'
  },

  // Association modal
  modal: {
    title: 'Select Country/Region',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} countries/regions, {total} available'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this country/region?',
    disableItem: 'Are you sure to disable this country/region?',
    batchEnable: 'Are you sure to enable the selected {count} countries/regions?',
    batchDisable: 'Are you sure to disable the selected {count} countries/regions?'
  },

  // Form validation
  validation: {
    selectItems: 'Please select countries/regions to associate'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select countries/regions to enable',
    selectToDisable: 'Please select countries/regions to disable',
    selectToAssociate: 'Please select countries/regions to associate',
    loadError: 'Failed to load country/region data, please try again later',
    platformLoadError: 'Failed to load platform country/region data, please try again later',
    continentLoadError: 'Failed to load continent data, please try again later',
    associateError: 'Failed to associate countries/regions, please try again later',
    associateSuccess: 'Successfully associated {count} countries/regions',
    statusToggleError: 'Failed to toggle status, please try again later',
    statusToggleSuccess: 'Country/region status updated successfully',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchEnableSuccess: 'Enabled {count} countries/regions',
    batchDisableError: 'Failed to batch disable, please try again later',
    batchDisableSuccess: 'Disabled {count} countries/regions'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // Continent names
  continents: {
    asia: 'Asia',
    europe: 'Europe',
    africa: 'Africa',
    northAmerica: 'North America',
    southAmerica: 'South America',
    oceania: 'Oceania',
    antarctica: 'Antarctica'
  }
}